import React from "react";
import { useI18n } from "../i18n/I18nContext";

export default function LegalPage({ sectionKey, testId }) {
  const { t, dict } = useI18n();
  const page = dict[sectionKey];

  return (
    <main className="bg-white" data-testid={testId}>
      <div className="bg-[#F8FAFC] border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-[10px] font-semibold uppercase tracking-widest text-[#C85A32] mb-2">
            Xeloriq Analytics S.A. · Argentina
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">
            {page.title}
          </h1>
          <p className="mt-3 text-xs font-mono text-[#64748B]">{page.last_updated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <p className="text-base text-[#334155] leading-relaxed">{page.intro}</p>

        <div className="mt-10 space-y-8">
          {page.sections.map((section, idx) => (
            <section key={idx} data-testid={`${sectionKey}-section-${idx + 1}`}>
              <h2 className="text-lg md:text-xl font-semibold text-[#0B2545]">
                {section.title}
              </h2>
              <p className="mt-3 text-sm md:text-base text-[#334155] leading-relaxed">
                {section.content}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-[#E2E8F0] text-xs text-[#64748B] space-y-1">
          <div>{t("footer.legal_company")}</div>
          <div>{t("footer.legal_cuit")}</div>
          <div>{t("footer.contact_address")}</div>
        </div>
      </div>
    </main>
  );
}
